module.exports = __webpack_public_path__ + "img/wp-new-habit-card15.d7957922.jpg";